import Buttons from '../Buttons/Buttons';
import style from './People.module.css';

export default function People({ maxPeople, people, setPeople, changePage }) {
    const click = () => {
        if (people) changePage(4);
    }

    return (
        <div className={style.container}>
            <div className={style.text}>Выберите количество гостей:</div>
            <div className={style.buttons_block}>
                {Array.from({ length: maxPeople }, (_, index) => (
                    <button key={`people-${index}`} className={`${style.button} ${people === index+1 && style.choose}`} onClick={() => setPeople(index+1)}>{index+1}</button>
                ))}
            </div>
            <Buttons button1={{ text: "Далее", onClick: click, disabled: !people }} button2={{ text: "Назад", onClick: () => changePage(2) }} />
        </div>
    )
}
